import React, {Component} from 'react';
import './App.css';
import {calculateDiff} from "./common/Map/Map";

import {saveAs} from 'file-saver/FileSaver'
import Hidden from "@material-ui/core/Hidden/Hidden";
import Desktop from "./desktop/Desktop";
import Mobile from "./mobile/Mobile";

import {defaultConfig} from './defaultConfig';

import {AppWrapper} from "./App.sc";

import {getMobileOperatingSystem} from "./Utils";

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lat: defaultConfig.lat,
            lng: defaultConfig.lng,
            boxSize: defaultConfig.boxSize,
            boxScale: defaultConfig.boxScale,
            verticalScale: defaultConfig.verticalScale,
            baseHeight: defaultConfig.baseHeight,
            waterDrop: defaultConfig.waterDrop,
            modelScale: defaultConfig.modelScale,

            loadingComplete: true,
            model: undefined
        };

        this.showDownloadButtons = getMobileOperatingSystem() !== "iOS";

        this.onClickGenerate = this.onClickGenerate.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
        this.onBoxChange = this.onBoxChange.bind(this);
        this.handleBoxSizeChange = this.handleBoxSizeChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleBoxScaleChange = this.handleBoxScaleChange.bind(this);
        this.handleWaterDropChange = this.handleWaterDropChange.bind(this);
        this.handleBaseHeightChange = this.handleBaseHeightChange.bind(this);
        this.handleVerticalScaleChange = this.handleVerticalScaleChange.bind(this);
        this.handleModelScaleChange = this.handleModelScaleChange.bind(this);
    }

    onBoxChange(lat, lng, boxSize, boxScale) {
        this.setState({
            lat,
            lng,
            boxSize,
            boxScale
        })
    }

    handleBoxSizeChange(value) {
        this.setState({
            boxSize: value
        })
    }

    handleLocationChange(lat, lng) {
        this.setState({
            lat: lat,
            lng: lng
        })
    }

    handleBoxScaleChange(value) {
        this.setState({
            boxScale: value
        })
    }

    handleWaterDropChange(value) {
        this.setState({
            waterDrop: value
        })
    }

    handleBaseHeightChange(value) {
        this.setState({
            baseHeight: value
        })
    }

    handleVerticalScaleChange(value) {
        this.setState({
            verticalScale: value
        })
    }

    handleModelScaleChange(value) {
        this.setState({
            modelScale: value
        })
    }

    onClickGenerate() {
        let {lat, lng, boxSize, verticalScale, baseHeight, waterDrop, boxScale, modelScale} = this.state;

        if (waterDrop >= baseHeight) {
            alert("Waterdrop cannot be greater or equal to the base height");
            return;
        }

        this.setState({
            loadingComplete: false
        });

        const d = calculateDiff(boxSize, boxScale);
        lat += d; // center to north west
        lng -= d; // center to north west

        const rotation = 0;

        fetch(`${process.env.REACT_APP_API_ENDPOINT}getSTL.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify({
                lat, lng, boxSize, vScale: verticalScale, rotation, waterDrop, baseHeight, boxScale, modelScale
            })
        })
            .then(result => result.arrayBuffer())
            .then(result => {
                this.setState({
                    loadingComplete: true,
                    model: result
                });
            })
            .catch(() => {
                this.setState({
                    loadingComplete: true
                });
                alert("Error creating model")
            });
    }

    onClickDownload() {
        const {model} = this.state;

        const blob = new Blob([model], {type: "application/octet-stream"});
        saveAs(blob, "map.stl");
    }

    render() {
        const {lat, lng, boxSize, verticalScale, baseHeight, waterDrop, boxScale, modelScale, model, loadingComplete} = this.state;

        return (
            <AppWrapper>
                <Hidden smDown>
                    <Desktop
                        lat={lat}
                        lng={lng}
                        boxSize={boxSize}
                        verticalScale={verticalScale}
                        baseHeight={baseHeight}
                        waterDrop={waterDrop}
                        boxScale={boxScale}
                        modelScale={modelScale}
                        model={model}
                        loadingComplete={loadingComplete}
                        zoom={defaultConfig.zoom}
                        handleBaseHeightChange={this.handleBaseHeightChange}
                        handleBoxScaleChange={this.handleBoxScaleChange}
                        handleBoxSizeChange={this.handleBoxSizeChange}
                        handleLocationChange={this.handleLocationChange}
                        handleVerticalScaleChange={this.handleVerticalScaleChange}
                        handleWaterDropChange={this.handleWaterDropChange}
                        handleModelScaleChange={this.handleModelScaleChange}
                        onBoxChange={this.onBoxChange}
                        onClickGenerate={this.onClickGenerate}
                        onClickDownload={this.onClickDownload}
                        showDownloadButtons={this.showDownloadButtons}
                    />
                </Hidden>
                <Hidden mdUp>
                    <Mobile
                        lat={lat}
                        lng={lng}
                        boxSize={boxSize}
                        verticalScale={verticalScale}
                        baseHeight={baseHeight}
                        waterDrop={waterDrop}
                        boxScale={boxScale}
                        modelScale={modelScale}
                        model={model}
                        loadingComplete={loadingComplete}
                        zoom={defaultConfig.zoom}
                        handleBaseHeightChange={this.handleBaseHeightChange}
                        handleBoxScaleChange={this.handleBoxScaleChange}
                        handleBoxSizeChange={this.handleBoxSizeChange}
                        handleLocationChange={this.handleLocationChange}
                        handleVerticalScaleChange={this.handleVerticalScaleChange}
                        handleWaterDropChange={this.handleWaterDropChange}
                        handleModelScaleChange={this.handleModelScaleChange}
                        onBoxChange={this.onBoxChange}
                        onClickGenerate={this.onClickGenerate}
                        onClickDownload={this.onClickDownload}
                        showDownloadButton={this.showDownloadButtons}
                    />
                </Hidden>
            </AppWrapper>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js